import type {
  WallAssemblyLayer,
  WallAssemblyStructuralLayer,
  WallAssemblySubstrateLayer,
  WallAssemblyMembraneLayer,
  WallAssemblyThermalLayer,
  WallAssemblyMaterialCatalogLayer,
  WallAssemblyInteriorFinishLayer,
  WallAssemblyExteriorFinishLayer,
  WallAssemblyFinishLayer,
  WallAssemblyAirGapLayer,
  WallAssemblyExteriorCladdingLayer,
  WallAssemblyInteriorCladdingLayer,
  WallAssemblyCladdingLayer,
} from "building-types/walls/wallAssemblyTypes";
import { WallMaterialType } from "building-types/walls/wallMaterialTypesEnum";

export function isStructuralLayer(layer: WallAssemblyLayer): layer is WallAssemblyStructuralLayer {
  return layer.type === WallMaterialType.STRUCTURE;
}

export function isSubstrateLayer(layer: WallAssemblyLayer): layer is WallAssemblySubstrateLayer {
  return layer.type === WallMaterialType.SUBSTRATE;
}

export function isMembraneLayer(layer: WallAssemblyLayer): layer is WallAssemblyMembraneLayer {
  return layer.type === WallMaterialType.MEMBRANE;
}

export function isThermalLayer(layer: WallAssemblyLayer): layer is WallAssemblyThermalLayer {
  return layer.type === WallMaterialType.THERMAL;
}

export function isMaterialCatalogLayer(layer: WallAssemblyLayer): layer is WallAssemblyMaterialCatalogLayer {
  return isStructuralLayer(layer) || isSubstrateLayer(layer) || isMembraneLayer(layer) || isThermalLayer(layer);
}

export function isInteriorFinishLayer(layer: WallAssemblyLayer): layer is WallAssemblyInteriorFinishLayer {
  return layer.type === WallMaterialType.INTERIOR_FINISH;
}

export function isExteriorFinishLayer(layer: WallAssemblyLayer): layer is WallAssemblyExteriorFinishLayer {
  return layer.type === WallMaterialType.EXTERIOR_FINISH;
}

export function isAirGapLayer(layer: WallAssemblyLayer): layer is WallAssemblyAirGapLayer {
  return layer.type === WallMaterialType.AIRGAP;
}

export function isFinishLayer(layer: WallAssemblyLayer): layer is WallAssemblyFinishLayer {
  return isInteriorFinishLayer(layer) || isExteriorFinishLayer(layer);
}

export function isExteriorCladdingLayer(layer: WallAssemblyLayer): layer is WallAssemblyExteriorCladdingLayer {
  return (
    isSubstrateLayer(layer) ||
    isAirGapLayer(layer) ||
    isThermalLayer(layer) ||
    isMembraneLayer(layer) ||
    isExteriorFinishLayer(layer)
  );
}

export function isInteriorCladdingLayer(layer: WallAssemblyLayer): layer is WallAssemblyInteriorCladdingLayer {
  return isInteriorFinishLayer(layer); // this is redundant, but we keep it because it will expand
}

export function isCladdingLayer(layer: WallAssemblyLayer): layer is WallAssemblyCladdingLayer {
  return isInteriorCladdingLayer(layer) || isExteriorCladdingLayer(layer);
}
